<!-- 审核 -->
<template>
  <div class="diseaseList">
    <!-- <HeaderTab :tabData="tabData" @clickTableTab="clickTableTab" style="margin: 0 0 40px;"/> -->
    <el-card class="box-card" v-if="active === 0">
      <!-- <div slot="header" class="clearfix">
        <span>有效期至1</span>
        <el-button style="float: right; padding: 3px 0" type="text"
          >过期</el-button
        >
      </div> -->
      <div>账号：{{ userInfo.username }} (可联系管理员修改)</div>
      <div>密码: (已加密)</div>
      <div>
        手机号：{{ userInfo.phone_number ? userInfo.phone_number : "暂无" }}
      </div>
      <div>创建日期：{{ userInfo.create_time }}</div>
      <!-- <div>账号有效期：{{ userInfo.useTime }}</div> -->
      <div>最近登录：{{ userInfo.update_time?userInfo.update_time:'暂未登录' }}</div> 
    </el-card>
    <el-button
      style="padding: 8px 10px; margin: 20px 0"
      @click="dialogVisible = true"
      v-waves
      >修改密码</el-button
    >
    <!-- 弹窗表单 -->
    <el-dialog
      :title="dialogName"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="dialogForm" label-width="100px">
        <el-form-item label="原密码" required>
          <el-input clearable v-model="dialogForm.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="修改密码:" required>
          <el-input
            clearable
            v-model="dialogForm.password"
            placeholder="输入密码自动md5加密"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" size="small" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button
          class="addBtn"
          size="small"
          type="primary"
          @click="save"
          v-waves
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { loginOut } from "@/services/user/index";
// import waves from "@/directive/waves/index.js"; // 水波纹指令
import { updatePassword } from "@/services/system/user.js";
// import md5 from "md5";
export default {
  components: {},
  async created() {
    // console.log(this.userInfo);
  },
  // directives: {
  //   waves,
  // },
  data() {
    return {
      active: 0,
      tabData: [
        { id: 0, title: "立即续费" },
        { id: 1, title: "订单记录" },
      ],
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
      },
      /* 表格数据 */
      tableData: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  watch: {},
  methods: {
    clickTableTab(e) {
      console.log(e);
      this.active = e.id;
    },
    async getListData(listQuery) {
      this.loading = true;
      const { data, code, count } = await selectOrder(
        listQuery || this.listQuery
      );
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },
    /* 搜索按钮 */
    async search(listQuery) {
      this.listQuery = listQuery;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建订单";
      this.dialogForm = {};
    },

    /* 修改 */
    handleEdit(row) {this.dialogVisible = true;
      this.dialogName = "编辑订单";
      // this.dialogForm = JSON.parse(JSON.stringify(row));
      this.dialogForm = {};
    },

    /* 保存 */
    save() {
      if (!this.dialogForm.oldPassword || !this.dialogForm.password) {
        this.$message.error("请填写必填字段");
        return;
      }
      this.$confirm("此操作将覆盖之前的密码, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const result = await updatePassword({
            ...this.userInfo,
            password: this.dialogForm.password,
            oldPassword: this.dialogForm.oldPassword,
          });
          if (result.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.dialogVisible = false;

            setTimeout(() => {
              this.$router.push({ name: "Login" });
              loginOut({ id: this.userInfo.id }).then((resp) => {
                this.$message({
                  type: "success",
                  message: "已注销登录!",
                });
              });
            }, 800);
          }
        })
        .catch(() => {});
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm("此操作将永久删除该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteOrder({ id: row.id }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },

    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 480px;

  div {
    margin: 10px 0;
  }
}

.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}
</style>
